export default __webpack_public_path__ + "static/similar-property-img-c49c58279d13a34946fefbb9d233334d.png";